import type { JerseySize } from './Jersey.types';

export function getJerseyDimensions(size: JerseySize): { width: number; height: number } {
  switch (size) {
    case 18:
      return { width: 18, height: 18 };
    case 32:
      return { width: 32, height: 32 };
    case 40:
      return { width: 40, height: 40 };
    case 50:
      return { width: 50, height: 50 };
    case 82:
      return { width: 82, height: 82 };
    case 95:
      return { width: 95, height: 95 };
    case 109:
      return { width: 109, height: 109 };
    default:
      return { width: 82, height: 82 };
  }
}
